export class GlobalConfig {
    static scrollbarOptions: MCustomScrollbar.CustomScrollbarOptions = { theme: 'minimal-dark', scrollInertia: 500, alwaysShowScrollbar: 0 };
}